import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './styles/styles.module.scss';

function SectionDivider({ children, classes }) {
  return (
    <div className={classNames(styles.wrapper, classes)}>
      <span className={styles.line} />
      <span className={styles.text}>{children}</span>
      <span className={styles.line} />
    </div>
  );
}

SectionDivider.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.string // might want to expand in the future
};

SectionDivider.defaultProps = {
  classes: null
};

export default SectionDivider;
